import { render, staticRenderFns } from "./DepartamentoPessoalDashboardTurnover.vue?vue&type=template&id=e9f31f14&scoped=true"
import script from "./DepartamentoPessoalDashboardTurnover.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalDashboardTurnover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f31f14",
  null
  
)

export default component.exports